import api from "api";
import store from "redux/store";

export const listSingleItemService = async (url: string, id: string) => {
  const response = await api.get(url + id, {
    headers: {
      Authorization: "Basic R0VPOkdFT0AjMzA=",
    },
  });

  return response;
};
